// 아래의 키값 중 snake case가 있는 경우는 api에서 그렇게 전달해주기 때문입니다..

export type Datas = DataType[];
export interface DataType {
  id: number;
  countryName: string;
  countryKey: string;
  canTravel: boolean;
  isTravelBubble: boolean;
  recoveryGuide: null | string;
  published_at: string;
  created_at: string;
  updated_at: string;
  countryFlag: string;
  source: null | string;
  view: number;
  linkType: LinkType;
  latest_at: string;
  iso_code: string;
  airport: null | string;
  cover_image: null | string;
  notice: Notice | null;
  summaryEntrance: Summary | null;
  vaccination: Vaccination | null;
  no_vaccination: Vaccination | null;
  summaryReturn: Summary | null;
  location: Location;
  cities: City[];
  covid_vaccines: Covid[];
  histories: History[];
}

export interface City {
  id: number;
  name: string;
  image: null | string;
  link: string;
}
export interface Covid {
  id: number;
  code: Code | IsolationCode;
  name: Name;
}

export enum Code {
  Az = "az",
  Janssen = "janssen",
  Moderna = "moderna",
  Pfizer = "pfizer",
}

export enum IsolationCode {
  Need = "NEED",
  No = "NO",
  NoEntrance = "NO_ENTRANCE",
  NoNegative = "NO_NEGATIVE",
}

export enum Name {
  Az = "아스트라제네카",
  Janssen = "얀센",
  Moderna = "모더나",
  Pfizer = "화이자",
}

export interface History {
  new_cases: number | null; // 신규 확진자
  new_cases_weekly: number | null; // 차트에 사용될 7일 평균
  vaccination_rate: number | null; // 백신 접종률
  update_date: string; // 업데이트 날짜
}

export enum LinkType {
  Cities = "cities",
  Countries = "countries",
}

export interface Location {
  id: number;
  latitude: number;
  longitude: number;
}
export interface Vaccination {
  id: number;
  entrance: Entrance;
  return: Entrance;
  entrance_prepare: PrepareLink[] | null;
  retrun_prepare: PrepareLink[] | null;
}

export interface Entrance {
  id: number;
  isolation: string;
  covidCheck: string;
  visa?: string;
  process: null | string;
}

export interface PrepareLink {
  id: number;
  label: string;
  url: string;
}

export interface Notice {
  id: number;
  title: string;
  contents: string;
}

export interface Summary {
  id: number;
  vaccination: SummaryEntranceNoVaccination;
  no_vaccination: SummaryEntranceNoVaccination;
}

export interface SummaryEntranceNoVaccination {
  id: number;
  period: number;
  covid_isolation: Covid;
}
